import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { indexOf, find, each } from 'lodash';
import { Modal, Button, Dropdown, MenuItem } from 'react-bootstrap';
import Fa from 'react-fontawesome';

class ProductMappingModal extends Component {
  constructor() {
    super();
    this.state = {};
    this.close = this.close.bind(this);
    this.submit = this.submit.bind(this);
  }

  close() {
    this.props.onClose();
  }

  submit() {
    this.props.onSubmit();
  }

  render() {
    const {
      isOpen, products, mappings, tvProducts,
    } = this.props;
    /*
    program: {
      productMappings: {
        truvoiceProductId: [product_id, product_id],
        truvoiceProductId: [product_id, product_id],
      }
    }
    */

    let filteredProducts = [];
    let checkedCount = 0;

    if (isOpen) {
      filteredProducts = products.map((product) => {
        // products = truvoice products
        const maps = {};
        let isMapped = false;
        each(tvProducts, (tvProduct) => {
          const mapping = mappings[tvProduct.id] || [];
          const checked = indexOf(mapping, product.product_id) >= 0;
          if (checked) {
            isMapped = true;
            checkedCount += 1;
          }
          maps[tvProduct.id] = checked;
        });
        return { ...product, mappings: maps, isMapped };
      });
    }

    const allChecked = checkedCount === filteredProducts.length;
    return (
      <Modal show={isOpen} backdrop="static" onHide={this.close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>Map TruSales Products to TruVoice Products</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div ref={(el) => { this.container = el; }}>
            <div className="well well-sm">
              <p>
                Review the following product(s) associated with the opportunities selected for submission to TruVoice.
                Map the product families defined in TruSales to the products defined in TruVoice.
              </p>
              <p>
                This step insures the opportunities are submitted with the correct focus product,
                or the primary product your consultant will gather feedback on during their discussions
                with the contacts being submitted.
              </p>
            </div>
            {filteredProducts.length > 0 &&
              <table className="table table-condensed table-striped">
                <thead>
                  <tr>
                    <th>TruSales Products</th>
                    <th>TruVoice Product Families</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredProducts.map((product) => {
                    let firstMappedId = null;
                    each(product.mappings, (v, k) => {
                      if (v) {
                        firstMappedId = k;
                      }
                    });
                    const activeProduct = firstMappedId ? find(tvProducts, { id: firstMappedId }) : null;
                    return (
                      <tr key={product.product_id}>
                        <td>
                          <div className={product.isMapped ? '' : 'text-danger'}>
                            {product.name}
                          </div>
                        </td>
                        <td>
                          <Dropdown
                            id={`product-dropdown-${product.product_id}`}
                            onToggle={this.handleToggle}
                            dropup
                          >
                            <Dropdown.Toggle bsSize="sm">
                              <span className={product.isMapped ? '' : 'text-danger'}>{(activeProduct ? activeProduct.name : 'Select a product')}</span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {tvProducts.map(tvProduct => (
                                <MenuItem
                                  key={tvProduct.id}
                                  active={activeProduct ? activeProduct.id === tvProduct.id : null}
                                  onSelect={() => {
                                    this.props.onToggle(tvProduct.id, product.product_id);
                                  }}
                                >
                                  {tvProduct.name}
                                </MenuItem>
                              ))}
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col-sm-6 col-sm-push-6">
              <div className="pull-right">
                <Button
                  bsStyle="primary"
                  disabled={!allChecked}
                  onClick={() => {
                  if (allChecked) {
                    this.submit();
                  }
                }}
                >
                  Submit
                </Button>
              </div>
            </div>
            <div className="col-sm-6 col-sm-pull-6">
              <div className="pull-left">
                <Button bsStyle="link" onClick={this.close}>Cancel</Button>
              </div>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

ProductMappingModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  mappings: PropTypes.shape({}).isRequired,
  tvProducts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  onToggle: PropTypes.func,
};
ProductMappingModal.defaultProps = {
  onClose: () => {},
  onSubmit: () => {},
  onToggle: () => {},
};

export default ProductMappingModal;
